import { Button } from "@babackapp/ui/components/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useTranslation } from "react-i18next";

interface ConfirmationModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	confirmVariant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
	onConfirm: () => void;
	onCancel?: () => void;
}

export function ConfirmationModal({
	open,
	onOpenChange,
	title,
	message,
	confirmText,
	cancelText,
	confirmVariant = "default",
	onConfirm,
	onCancel,
}: ConfirmationModalProps) {
	const { t } = useTranslation("trackoffice");

	const handleConfirm = () => {
		onConfirm();
		onOpenChange(false);
	};

	const handleCancel = () => {
		onCancel?.();
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{message}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button variant="outline" onClick={handleCancel}>
						{cancelText || t("common.cancel", "Cancel")}
					</Button>
					<Button variant={confirmVariant} onClick={handleConfirm}>
						{confirmText || t("common.confirm", "Confirm")}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}